export namespace Logic {

    export class Type {

        private static none = new Type(new class implements Type.Model<Type> {
            Update(value: Type): void {
            }
        })

        private model: Type.Model<Type>

        // tslint:disable-next-line:no-shadowed-variable
        static New<Type extends Logic.Type>(value: Type, state: Partial<Type>): Type {

            if (value == state) { 
                return value
            }

            let t = Object.assign(new (value.constructor as Type.Class<Type>)(value.model), value, state) as Type
            for (let m in t as {} as {[name: string]: Logic.Type | void}) {

                let x = (t as {} as {[name: string]: Logic.Type | void})[m]

                if (x instanceof Type) {
                    Type.Add(t, x)
                }
            }
            t.model.Update(t)
            return t
        }

        // tslint:disable-next-line:no-shadowed-variable
        static Add<Host extends Logic.Type, Type extends Logic.Type>(owner: Host, field: Type): Type {
            let t = new class implements Type.Model<Type> {
                Update(value: Type): void {
                    for (let m in owner as {} as {[name: string]: Logic.Type | void}) {
                        let x = (owner as {} as {[name: string]: Logic.Type | void})[m]

                        if (x == field) {
                            Type.New(owner, {[m]: value} as {} as Partial<Host>)
                        }
                    }
                }
            }
            field.model = t
            return field
        }

        constructor(model?: Type.Model<Type>) {
            this.model = model ? model : Type.none.model
        }

    }

    export namespace Type {
        // tslint:disable-next-line:no-shadowed-variable
        export interface Model<Type extends Logic.Type> {
            Update(value: Type): void
        }

        // tslint:disable-next-line:no-shadowed-variable
        export interface Class<Type extends Logic.Type> {
            new(model: Type.Model<Type>): Type
        }
    }
 

}



// WEBPACK FOOTER //
// ./src/Logic/Type.ts